import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { first, Subscription } from 'rxjs';
import { SignalUser } from '../../models/SignalUser/SignalUser';
import { environment } from 'src/environments/environment';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';
@Injectable({
  providedIn: 'root'
})

export class SignalUserAPIService implements IApiBase{
 
  configUrl: string;
  subscription_AddSignalUser: Subscription;
  subscription_DeleteSignalUser: Subscription;

  constructor(private http: HttpClient) {
  this.configUrl = environment.signalRHost;
}
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

AddSignalUser(signalUser: SignalUser): any {
  if(!environment.production) console.log("/api/External/InsertSignalUser/");
  return this.http.post(this.configUrl + '/api/External/InsertSignalUser?ConnectionId='+signalUser.ConnectionId+'&&Identifier='+signalUser.Identifier,{});
}

DeleteByUser() {
  if(!environment.production) console.log("/api/External/DeleteSignalUser/");
  return this.http.get(this.configUrl + "/api/External/DeleteSignalUser/",{});
}
DeleteByUserIdentifier(identifier: string) {
  if(!environment.production) console.log("/api/External/DeleteSignalUser/");
  return this.http.get(this.configUrl + "/api/External/DeleteSignalUser?identifier="+identifier,{});
}
}
